import cx from 'classnames'

import Badge from 'react-bootstrap/Badge'
import Typography from '../../Typography/Typography'
import { BADGE_TYPE } from './constants'

import './BadgeCinestar.scss'

const BadgeCinestar = ({ children, type = BADGE_TYPE.filled, className = '' }) => {
    const classNameBadge = cx(`badge-cinestar rounded-0 ${className}`, {
        'bg-formPrimary': type === BADGE_TYPE.filled,
        'bg-transparent border border-lighterPrimary': type === 'outline',
    })

    const textColor = type === BADGE_TYPE.filled ? 'basePrimary' : 'primary'

    return (
        <Badge className={classNameBadge}>
            <Typography variant={'badge'} color={textColor}>
                {children}
            </Typography>
        </Badge>
    )
}

export default BadgeCinestar
